
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRestaurants, deleteRestaurant, toggleRestaurantStatus } from '../redux/restaurantSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Table from '../common/Table';
import Swal from "sweetalert2";

const RestaurantList = () => {
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector((state) => state.restaurant);
    const [statusToChange, setStatusToChange] = useState(null);
    const [sortedData, setSortedData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        dispatch(fetchRestaurants());
    }, [dispatch]);

    useEffect(() => {
        if (data && Array.isArray(data)) {
            const sorted = [...data].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setSortedData(sorted);
        }
    }, [data]);

    const handleSwitchChange = (id, currentStatus) => {
        const newStatus = currentStatus === 1 ? 0 : 1;
        setStatusToChange({ id, newStatus });
        dispatch(toggleRestaurantStatus({ id, status: newStatus }));
    };

    useEffect(() => {
        if (!loading && statusToChange) {
            toast.success(
                `Restaurant status changed to ${statusToChange.newStatus === 1 ? "active" : "inactive"}`
            );
            setTimeout(() => {
                setStatusToChange(null);
            }, 2000);
        }
    }, [loading, statusToChange]);

    const handleDeleteClick = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            customClass: {
                popup: 'custom-swal-popup',
                title: 'custom-swal-title',
                content: 'custom-swal-content',
                confirmButton: 'custom-swal-button',
                cancelButton: 'custom-swal-button'
            }
        });
        if (result.isConfirmed) {
            if (id) {
                dispatch(deleteRestaurant(id))
                    .then(() => {
                        Swal.fire("Deleted!", "Restaurant has been deleted.", "success");
                    })
                    .catch((error) => {
                        Swal.fire(
                            "Error!",
                            error.response?.data?.message || "Error deleting restaurant",
                            "error"
                        );
                    });
            }
        }
    };

    const filteredData = sortedData.filter(restaurant =>
        restaurant.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        restaurant.user?.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const options = ['S No.', 'Profile', 'Name', 'Owner', 'Status', 'Actions'];

    if (error) return <div>{error}<br />Please try again after some time or check your internet connection.</div>;
    return (
        <>
            <Table
                restaurant='restaurant'
                heading='Restaurants'
                options={options}
                data={filteredData}
                handleSwitchChange={handleSwitchChange}
                handleDeleteClick={handleDeleteClick}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                loading={loading}
            />

            <ToastContainer
                position='top-right'
                autoClose={1000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {loading && (
                <div className="loader" style={{ position: 'absolute', top: '50%', left: '59%', transform: 'translate(-50%, -50%)' }}>
                    <div className="spinner-border text-info" role="status" style={{ width: '50px', height: '50px' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default RestaurantList;